<template>
  <v-row>

    <!-- ヘッダ -->
    <v-col cols="12">
      <c-block-header :block="block"/>
    </v-col>

    <!-- 車両カード -->
    <v-col
      v-for="car in block.cars"
      :key="car.id"
      cols="12" sm="6"
    >
      <c-car-card :car="car"/>
    </v-col>

  </v-row>
</template>

<script>
import CBlockHeader from './CBlockHeader'
import CCarCard from './CCarCard'

export default {
  name: 'CBlock',
  components: {
    CBlockHeader,
    CCarCard
  },

  props: {
    block: {
      type: Object,
      required: true
    }
  }
}
</script>
